import { buildQuery, requestJson } from "./apiClient";

export function listClientViewQueryProfiles(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/query-profiles`);
}

export function getClientViewQueryProfile(clientViewId, profileId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/query-profiles/${profileId}`);
}

export function createClientViewQueryProfile(clientViewId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/query-profiles`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateClientViewQueryProfile(clientViewId, profileId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/query-profiles/${profileId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deactivateClientViewQueryProfile(clientViewId, profileId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/query-profiles/${profileId}`, {
    method: "DELETE",
  });
}

export function previewClientViewQueryProfile(clientViewId, profileId, payload = {}) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/query-profiles/${profileId}/preview`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}
